import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router';
import { getTopic } from '../../services/topicService';
import { getQuizzes } from '../../services/quizService';
import BackLink from '../../components/ui/BackLink';
import Breadcrumbs from '../../components/ui/Breadcrumbs';
import { useAuth } from '../../contexts/authContext';
import LoginPromptModal from '../../components/modals/LoginPromptModal';

const QuizDetailPage = () => {
  const { topic_id } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [showLoginPrompt, setShowLoginPrompt] = useState(false);
  const [topic, setTopic] = useState(null);
  const [quizzes, setQuizzes] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTopicAndQuizzes = async () => {
      try {
        const topicData = await getTopic(topic_id);
        setTopic(topicData);

        const quizzes = await getQuizzes({ topic_id });
        setQuizzes(quizzes)
      } catch (error) {
        console.error('Error fetching topic or quizzes:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchTopicAndQuizzes();
  }, [topic_id]);

  const handleStartQuiz = (quizId) => {
    if (!user) {
      setShowLoginPrompt(true);
    } else {
      navigate(`/quizzes/${quizId}/view`);
    }
  };

  if (loading) {
    return <div className="text-center py-4">Loading...</div>;
  }

  if (!topic) {
    return <div className="text-center py-4">Topic not found</div>;
  }

  return (
    <div className="max-w-5xl mx-auto p-4">
      <Breadcrumbs
        items={[
          { text: 'Discover', url: '/discover' },
          { text: topic.title, url: `/topics/${topic.id}` },
        ]} 
        className="mb-5 mt-3" 
      />

      {topic?.image ? (
        <figure>
          <img src={topic?.image || "/placeholder.svg"} alt={topic.title} className="w-full h-48 object-cover" />
        </figure>
      ) : (
        <div className="h-48 bg-base-300 flex items-center justify-center rounded-lg">
          <span className="text-base-content/50">No image available</span>
        </div>
      )}
      <div className="mt-4">
        <h1 className="text-4xl font-medium font-inter text-gray-800 mb-4">{topic.title}</h1>
        <p className="text-gray-700">{topic.description}</p>
      </div>

      <h2 className="text-2xl font-medium text-gray-700 my-4">Quizzes</h2>
      {quizzes.length == 0 && (
        <div className='text-center mt-10'>
            <span className='text-xl'>Sorry 🥲</span>
            <p className='font-medium italic text-lg'>Quiz has not been set for this topic.</p>
        </div>
      )}
      {quizzes ? (
        <div className="flex gap-2">
          { quizzes.map((quiz) => (
              <button
                key={quiz.id}
                className="btn btn-primary mt-4"
                onClick={() => handleStartQuiz(quiz.id)}
              >
                Start {quiz.quiz_type} Quiz
              </button>
            ))
          }
        </div>
      ) : (
        <p className="text-gray-600">Sorry. no quizzes available for this topic 🥲.</p>
      )}

      <LoginPromptModal 
        isOpen={showLoginPrompt} 
        onClose={() => setShowLoginPrompt(false)}
        description={'You need to be logged in to take this quiz'}
      />
    </div>
  );
};

export default QuizDetailPage;
